// extracted by mini-css-extract-plugin
export default {"PatientInfoPop":"PatientInfoPop_PatientInfoPop__poNIK"};